<div class="cx_spinner__container">
  <div class="cx_spinner__loaderText">
    <span>Cargando...</span>
  </div>
  <div class="cx_spinner__loader"></div>
</div>
